import React, { useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { VehicleForm } from '../components/vehicles/VehicleForm';

export const VehicleEditPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  // TODO: Replace with Toolpad navigation
  const currentProject = null;
  const [formOpen] = useState(true);
  
  const vehicleData = location.state?.vehicle;
  const isNewVehicle = !id; // If no ID in URL, we're creating a new vehicle

  const handleSuccess = () => {
    // Navigate back to project-aware data management vehicles tab
    if (currentProject) {
      navigate(`/projects/${currentProject.id}/data-management?tab=vehicles`);
    } else {
      navigate('/projects');
    }
  };

  const handleClose = () => {
    // Navigate back to project-aware data management vehicles tab
    if (currentProject) {
      navigate(`/projects/${currentProject.id}/data-management?tab=vehicles`);
    } else {
      navigate('/projects');
    }
  };

  // For edit mode, we need vehicle data. For new mode, we don't.
  if (!isNewVehicle && !vehicleData) {
    return (
      <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
        <Typography variant="h6" color="error">
          Vehicle data not found. Please navigate from the vehicles page.
        </Typography>
        <Button
          startIcon={<ArrowBack />}
          onClick={handleClose}
          variant="outlined"
          sx={{ mt: 2 }}
        >
          Back to Vehicles
        </Button>
      </Box>
    );
  }

  if (!currentProject) {
    return (
      <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
        <Typography variant="h6" color="error">
          Please select a project first.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={handleClose}
          variant="outlined"
          size="small"
        >
          Back to Vehicles
        </Button>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 700 }}>
          {isNewVehicle ? 'Add New Vehicle' : `Edit Vehicle: ${vehicleData?.description || 'New Vehicle'}`}
        </Typography>
      </Box>

      <VehicleForm
        open={formOpen}
        onClose={handleClose}
        projectId={currentProject.id}
        vehicle={isNewVehicle ? undefined : vehicleData}
        onSuccess={handleSuccess}
      />
    </Box>
  );
};